import React from 'react';
import '../../assets/css/authenticationStyles.css';
import auth_page_baackground from '../../assets/images/auth_page_background.png';

export default function AuthWrapper({children}) {
  return (
    <div className='authContainer'>
      {/* Left Grid Item Which Contains Form */}
        <div className='authImgContainer'>
            <img src={auth_page_baackground} alt='Authentication Form Background' className='authImage' />
            <div className="overlay"></div>
            {/* <img src={notap_logo} alt='Logo' className='overlayLogo' /> */}
        </div>  
    

      {/* Right Grid Item Which Contains Image */}
        <div className='leftSideContainer px-2 px-sm-40'>

            {/* App Logo Container */}
            {/* <div style={{width: '100%'}}>
            <img src={notap_logo} alt='logo' className='logotypeImage' />
            </div> */}

            {/*Form */}
            {children}
        </div>      
    </div>
  )
}
